import { signInWithEmailAndPassword, signOut } from "./api/api";

async function logInWithEmailAndPassword(login, password) {
	try {
		const res = await signInWithEmailAndPassword(JSON.stringify({login, password}))
		if(res.ok){
			const token = await res.json();
			localStorage.setItem("userToken", token.result)
		}
	} catch (error) {
		console.log(error)
	}
}

async function logout() {
	localStorage.removeItem("userToken")
}

export { logInWithEmailAndPassword, logout };
